import { render, staticRenderFns } from "./AppHistoryPanel.vue?vue&type=template&id=a3b187e4&scoped=true&"
import script from "./AppHistoryPanel.vue?vue&type=script&lang=js&"
export * from "./AppHistoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppHistoryPanel.vue?vue&type=style&index=0&id=a3b187e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b187e4",
  null
  
)

export default component.exports